import { Color } from '@tmh-website/shared/colors';
import StyledTypo from '@tmh-website/styles/typo';
import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

export interface FormResultMessageProps {
  marginTop?: boolean;
  children: ReactNode;
}

export const Container = styled.div<{ $marginTop?: boolean; $variant: 'error' | 'success' | 'warning' }>`
  ${StyledTypo.uiTextCss};
  display: flex;
  align-items: center;
  padding: 12px 20px 12px 14px;
  margin-top: 24px;
  border-radius: ${props => props.theme.borderRadius.large};

  ${props =>
    props.$variant === 'error' &&
    css`
      background-color: ${props.theme.color[Color.Red_500_Danger]};
      color: ${props => props.theme.color[Color.Neutral_0_White]};
    `}

  ${props =>
    props.$variant === 'success' &&
    css`
      background-color: ${props.theme.color[Color.Green_500_Success]};
      color: ${props => props.theme.color[Color.Neutral_0_White]};
    `}
      
      ${props =>
    props.$variant === 'warning' &&
    css`
      background-color: ${props.theme.color[Color.Yellow_500_Warning]};
      color: ${props => props.theme.color[Color.Blue_1000_Deep]};
    `}

  > svg {
    flex-shrink: 0;
    align-self: flex-start;
    margin-right: 12px;
  }
`;
